import React, { useState, useEffect } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    FormGroup,
    FormControlLabel,
    Switch
} from "@mui/material";
import Loading from "../../../Components/Loading/Loading";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import { TextInput } from "../../../Components/Input/Input";
import {
    AlertError,
    AlertSuccess,
    AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import axios from "axios";

const AddZone = (props) => {
    const [loading, setLoading] = useState(false)
    const [zoneTitle, setZoneTitle] = useState('')
    const [zoneTitleErr, setZoneTitleErr] = useState(false)
    const [remark, setRemark] = useState('')
    const [status, setStatus] = useState(true)
    const [zoneID, setZoneID] = useState()

    useEffect(() => {
        if (!props.zoneID) return
        setZoneID(props.zoneID);
    }, [])

    useEffect(() => {
        if (!zoneID) return
        getData(zoneID)
    }, [zoneID])

    const getData = async (id) => {
        await axios
            .get(
                UrlApi + `get_zone_edit?zone_id=${id}`,
                authorization
            )
            .then((res) => {
                res.data.map((item) => {
                    setZoneTitle(item.zone_master_name)
                    setRemark(item.zone_master_remark)
                    setStatus(item.zone_master_active)
                })
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                AlertError(err);
            });
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        if (zoneTitle === "") {
            setZoneTitleErr(true);
            return false;
        } else {
            setZoneTitleErr(false);
        }

        if (!props.zoneID) {
            setLoading(true);
            const body = {
                zoneTitle,
                remark,
                status,
            };
            await axios
                .post(UrlApi + "save_zone", body, authorization)
                .then((res) => {
                    if (res.data.status === 1) {
                        props.onCancel();
                        AlertSuccess(res.data.message);
                        setLoading(false);
                    } else {
                        props.onCancel();
                        AlertWarning(res.data.message);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    AlertError(err);
                });
        } else {
            setLoading(true);
            const body = {
                zoneTitle: zoneTitle,
                remark: remark,
                status: status,
                zoneID: props.zoneID
            };
            await axios
                .put(UrlApi + "update_zone", body, authorization)
                .then((res) => {
                    if (res.data.status === 1) {
                        props.onCancel();
                        AlertSuccess(res.data.message);
                        setLoading(false);
                    } else {
                        props.onCancel();
                        AlertWarning(res.data.message);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    AlertError(err);
                });
        }
    };

    return (
        <>
            <Dialog
                open={props.open}
                maxWidth="1500"
                PaperProps={{ style: { borderRadius: 10, width: '600px' } }}
            >
                <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
                    <DialogTitle>
                        <label>
                            เพิ่มพื้นที่สั่งงาน
                        </label>
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <form>
                            <table style={{ width: '100%' }}>
                                <tr>
                                    <td colSpan="5">
                                        <label style={{ marginLeft: '9px' }}>ชื่อโซน</label>
                                        {
                                            <TextInput
                                                autoFocus={true}
                                                value={zoneTitle}
                                                error={zoneTitleErr}
                                                onChange={(e) => {
                                                    setZoneTitle(e.target.value);
                                                    setZoneTitleErr(false)
                                                }}
                                                width="100%"
                                            />
                                        }
                                    </td>

                                </tr>
                                <tr>
                                    <td colSpan="5">
                                        <label style={{ marginLeft: '9px' }}>หมายเหตุ</label>
                                        {
                                            <TextInput
                                                value={remark}
                                                onChange={(e) => {
                                                    setRemark(e.target.value);
                                                }}
                                                width="100%"
                                            />
                                        }
                                    </td>

                                </tr>
                                <tr>
                                    <td colSpan="5">
                                        <label style={{ marginLeft: '9px' }}>สถานะการใช้งาน</label>
                                        {
                                            <FormGroup style={{ marginLeft: "10px" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={status}
                                                            onChange={() => {
                                                                setStatus(!status);
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        status ? (
                                                            <label>เปิดการใช้งาน</label>
                                                        ) : (
                                                            <label>ปิดการใช้งาน</label>
                                                        )
                                                    }
                                                />
                                            </FormGroup>
                                        }
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <ButtonSave type="submit" />
                        <ButtonClose onClick={() => props.onCancel()} />
                    </DialogActions>
                    <Loading open={loading} />
                </Box>
            </Dialog>
        </>
    )
}

export default AddZone